<template>
  <div class="upload-button">
    <button class="button open danger" @click="onClick">
      <p class="open__text">
        <slot />
        {{ `${buttonText} (${uploadsCount})` }}
        <i v-if="isOpen" class="fa fa-caret-up open__icon ml-20" aria-hidden="true" />
        <i v-else class="fa fa-caret-down open__icon ml-20" aria-hidden="true" />
      </p>
    </button>
  </div>
</template>

<script>
export default {
  name: 'UnfinishedUploadsButton',

  props: {
    buttonText: {
      type: String,
      required: true,
    },
    uploadsCount: {
      type: Number,
      required: true,
    },
    isOpen: {
      type: Boolean,
      required: true,
    },
  },

  methods: {
    onClick() {
      this.$emit('click');
    },
  },
};
</script>



// WEBPACK FOOTER //
// UnfinishedUploadsButton.vue?57ea2b9a